import { useContext, useMemo, useEffect } from "react";
import { SprintContext, FINISH_TAG } from '../SprintContext';
import GenericTable from "../Components/generic/GenericTable";
import Canvas from "../Components/Canvas";
import './Sprint.css';

const aggregateFastest = false;

const focusFastest = false;

const TeamPursuit = () => {
    const { laps, fastestLap, lapBuilder, targetRider } = useContext(SprintContext);

    useEffect(() => {
        console.log(laps)
        // Trigger a redraw or any necessary updates when SprintContext changes
        // This effect will run whenever laps, fastestLap, lapBuilder, or targetRider changes
        
    }, [laps]);

    return (
        <Canvas showTime>
            <GenericTable doAutoScroll={false} laps={laps} fullSize={true} forceRender={false} type="team_pursuit"/>
        </Canvas>
    );
};

export default TeamPursuit;